import { useTranslation } from "react-i18next";

import { Badge } from "@nexus/ui";
import type { MarketplaceFulfillmentStatus } from "@nexus/contracts";

import {
  fulfillmentBadgeVariant,
  type MarketplaceFulfillmentViewer,
} from "../lib/fulfillment-badge-variant";
import { getFulfillmentStatusLabel } from "../lib/fulfillment-status-label";

export function FulfillmentStatusBadge({
  status,
  viewer = "client",
}: {
  status: MarketplaceFulfillmentStatus;
  viewer?: MarketplaceFulfillmentViewer;
}) {
  const { t } = useTranslation();

  return (
    <Badge variant={fulfillmentBadgeVariant(status, viewer)} dot>
      {getFulfillmentStatusLabel(t, status, viewer)}
    </Badge>
  );
}
